export default "__VITE_ASSET__CaNm3P5H__"